<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-28 19:04:17
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Leave\LeaveApplication\viewLeaveApplication.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-11-15 09:44:56
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_leaveApplication_form_viewTitle')"
    backgroundClass="transparent"
    widthClass="max-1000"
    @delete="toDelete"
    pad="0"
  >
    <!-- content -->
    <template v-slot:page-main>
      <noContent v-if="!Data" />
      <ApprovalTriger
        v-if="Data"
        :bg-color="Data.approval_bg_color"
        :slide-color="Data.approval_tint_color"
        @triger="
          $toPage(
            '/admin/leave-application/detail/' +
              $route.params.params +
              '/approval-detail/' +
              $route.params.params
          )
        "
      >
        <template v-slot:time>
          {{ $getDateTime(Data.operate_utc_datetime, "YYYY/MM/DD HH:mm") }}
        </template>
        <template v-slot:status>
          {{ $getCommonLangValue(Data.status_detail) }}
        </template>
      </ApprovalTriger>

      <Section>
        <v-row>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_leaveApplication_form_swiftNumberLabel")
            }}</v-sheet>
            <v-text-field
              readonly
              v-model="Data.swift_number"
              :label="$t('label_essweb_leaveApplication_form_swiftNumberLabel')"
              single-line
              dense
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_leaveApplication_form_submitDateLabel")
            }}</v-sheet>
            <v-text-field
              readonly
              :value="
                $getDateTime(Data.submission_utc_datetime, 'YYYY/MM/DD HH:mm')
              "
              :label="$t('label_essweb_leaveApplication_form_submitDateLabel')"
              single-line
              dense
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_leaveApplication_form_applicantLabel")
            }}</v-sheet>
            <v-autocomplete
              single-line
              v-model="user"
              readonly
              :items="users"
              append-icon
              item-value="uuid"
            >
              <template v-slot:no-data>
                <noContent />
              </template>
              <template v-slot:selection="data">
                <v-chip pill v-bind="data.attrs" :input-value="data.selected">
                  <StaffAvatar
                    left
                    :src="data.item.staff_avatar"
                    :staff_name="data.item.preferred_name"
                  />
                  {{ $getCommonLangValue(data.item.preferred_name) }}
                </v-chip>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </Section>
      <Section>
        <v-row>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_leaveApplication_form_leaveTypeLabel")
            }}</v-sheet>
            <v-text-field
              readonly
              :value="
                $getCommonLangValue(Data.leave_type_name) +
                (Number(Data.cancel_flag) == 1
                  ? '(' +
                    $t('label_essweb_LeaveApplication_list_tag_cancelLabel') +
                    ')'
                  : '')
              "
              :label="$t('label_essweb_leaveApplication_form_leaveTypeLabel')"
              single-line
              dense
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_leaveApplication_form_leaveTransactionTypeLabel")
            }}</v-sheet>
            <v-text-field
              readonly
              :value="$getCommonLangValue(Data.leave_transaction_type_name)"
              :label="
                $t(
                  'label_essweb_leaveApplication_form_leaveTransactionTypeLabel'
                )
              "
              single-line
              dense
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_leaveApplication_form_startDateLabel")
            }}</v-sheet>
            <v-text-field
              readonly
              :value="$getDateTime(Data.start_utc_datetime, 'YYYY/MM/DD HH:mm')"
              :label="$t('label_essweb_leaveApplication_form_startDateLabel')"
              single-line
              dense
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_leaveApplication_form_endDateLabel")
            }}</v-sheet>
            <v-text-field
              readonly
              :value="$getDateTime(Data.end_utc_datetime, 'YYYY/MM/DD HH:mm')"
              :label="$t('label_essweb_leaveApplication_form_endDateLabel')"
              single-line
              dense
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_leaveApplication_form_durationLabel")
            }}</v-sheet>
            <v-text-field
              readonly
              :value="
                parseFloat(Number(Data.total_time || 0)) +
                (Data.unit === 'D'
                  ? $t('label_essweb_system_dayLabel')
                  : Data.unit === 'H'
                  ? $t('label_essweb_system_hourLabel')
                  : '')
              "
              :label="$t('label_essweb_leaveApplication_form_durationLabel')"
              single-line
              dense
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_leaveApplication_form_leaveReasonLabel")
            }}</v-sheet>
            <v-text-field
              readonly
              :value="$getCommonLangValue(Data.leave_reason_name)"
              :label="$t('label_essweb_leaveApplication_form_leaveReasonLabel')"
              single-line
              dense
            ></v-text-field>
          </v-col>
          <v-col
            xs="12"
            sm="12"
            md="12"
            lg="12"
            cols="12"
            v-if="Data.attachments.length != 0"
          >
            <v-sheet class="text--secondary">{{
              $t("label_essweb_leaveApplication_form_attachmentLabel")
            }}</v-sheet>
            <ImgDragUpdate :defaultImageList="Data.attachments" disabled />
          </v-col>

          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_leaveApplication_form_messageLabel")
            }}</v-sheet>
            <v-text-field
              readonly
              v-model="Data.remarks"
              :label="$t('label_essweb_leaveApplication_form_messageLabel')"
              single-line
              dense
            ></v-text-field>
          </v-col>
        </v-row>
      </Section>
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "viewLeavedApplication",
  computed: {},
  data() {
    return {
      Data: { attachments: [] },
      users: [],
      user: null,
      page_params: null,
    };
  },
  mounted() {
    this.page_params = JSON.parse(this.$aesDecrypt(this.$route.params.params)); //解密参数
    this.getDetail();
  },
  filters: {
    getDuration(obj, calback) {
      return calback(obj);
    },
  },
  methods: {
    getDuration(obj) {
      let day = Number(obj["number_of_day"] || 0);
      let minutes = Number(obj["number_of_minutes"] || 0);
      var str = "";
      if (minutes == 0 && day == 0) {
        str =
          day +
          this.$t("label_essweb_system_dayLabel") +
          0 +
          this.$t("label_essweb_system_hourLabel") +
          minutes +
          this.$t("label_essweb_system_minutesLabel");
      }
      if (day > 0) {
        str += day + this.$t("label_essweb_system_dayLabel");
      }

      if (minutes > 0 && minutes < 60) {
        str += minutes + this.$t("label_essweb_system_minutesLabel");
      }
      if (minutes > 0 && minutes > 60) {
        str +=
          Math.floor(minutes / 60) +
          this.$t("label_essweb_system_hourLabel") +
          (minutes % 60) +
          this.$t("label_essweb_system_minutesLabel");
      }
      return str;
    },
    toDelete: function () {},
    getDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_application_record",
        url: "/leave-application-record/get-details/",
        data: { uuid: this.page_params.id },
      }).then((res) => {
        that.user = res.data.uuid;
        that.users = [
          {
            staff_avatar: res.data.agent_staff.staff_avatar,
            uuid: res.data.uuid,
            preferred_name: res.data.agent_staff.preferred_name,
          },
        ];
        if (res.data["attachments"]) {
          res.data["attachments"].map((item) => {
            item["uuid"] = item["uuid"];
            item["file_name"] = item["file_name"];
            item["path"] = item["url"];
            item["size"] = item["attachment_size"];
          });
        } else {
          res.data["attachments"] = [];
        }
        that.Data = res.data;
      });
    },
  },
};
</script>
